<template>
  <div class="card modal-card-border modal-card-panier">
    <div class="card-content">
      <header>
        <b-icon
          icon="checkbox-marked-circle-outline"
          class="cloud-check"
          size="is-large"
          type="is-success">
        </b-icon>
        <br>
      </header>
      <section>
        <p class="subtitle is-4 has-text-centered">
          Votre opportunité a été enregistrée avec succès.</p>
      </section>
      <br>
      <footer>
        <div class="columns">
            <div class="column has-text-centered">
              <a ref="lienDownload"></a>
              <button class="button is-primary margin-right-10" @click="exporterPdf()">
                <b-icon
                  icon="file-pdf-box" class="margin-right-10">
                </b-icon>
                Exporter en PDF
              </button>
              <b-dropdown aria-role="list">
              <button
                class="button is-primary margin-right-10"
                v-if="this.opportunite.afficherRecap"
                slot="trigger">
                <b-icon
                  icon="download" class="margin-right-10">
                </b-icon>
                Exporter le récapitulatif réseau
              </button>

              <b-dropdown-item
                aria-role="listitem"
                @click="recapitulatif('PDF')">
                Format PDF
              </b-dropdown-item>
              <b-dropdown-item
                aria-role="listitem"
                @click="recapitulatif('EXCEL')">
                Format Excel
              </b-dropdown-item>
            </b-dropdown>
              <button class="button is-primary" @click="ouvrirModalEnvoiMail()">
                <b-icon
                  icon="email" class="margin-right-10">
                </b-icon>
                Envoyer par email
              </button>
            </div>
          </div>
        <b-field  grouped v-if="hasPortailAnnonceur === true">
          <b-field  label="Partagez votre opportunité dématérialisée avec le lien ci-dessous."
                    custom-class="is-size-7 couleurFontDefault" expanded>
            <b-field>
              <b-input :value="opportunite.permalink" expanded id="link"></b-input>
                <button class="button is-primary margin-right-10" @click="copyLink()">
                  <b-icon
                    icon="link-variant" class="margin-right-10">
                  </b-icon>
                  Copier
                </button>
                <button class="button is-primary" @click="ouvrirNouvelleFenetre()">
                  <b-icon
                    icon="open-in-new" class="margin-right-10">
                  </b-icon>
                  Ouvrir
                </button>
            </b-field>
          </b-field>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import HTTP from '@/api/HTTP';
import gestionErreur from '@/services/general/gestionErreur';
import toastConfirmation from '@/services/general/toastConfirmation';

const User = createNamespacedHelpers('user');
const Panier = createNamespacedHelpers('panier');
const Modal = createNamespacedHelpers('modal');

export default {
  name: 'enregistrer-opportunite',
  computed: {
    ...Panier.mapGetters({
      opportunite: 'opportunite',
    }),
    ...Modal.mapGetters({
      getOuvrirEnvoiMail: 'ouvrirEnvoiMail',
      getIsComponentOuvrirEnvoiMail: 'isComponentOuvrirEnvoiMail',
      getIsComponentEnregistrerOpportuniteActive: 'isComponentEnregistrerOpportuniteActive',
    }),
    ...User.mapGetters({
      hasPortailAnnonceur: 'hasPortailAnnonceur',
    }),
    ouvrirEnvoiMail: {
      get() {
        return this.getOuvrirEnvoiMail;
      },
      set(value) {
        this.setOuvrirEnvoiMail(value);
      },
    },
    isComponentOuvrirEnvoiMail: {
      get() {
        return this.getIsComponentOuvrirEnvoiMail;
      },
      set(value) {
        this.setIsComponentOuvrirMail(value);
      },
    },
    isComponentEnregistrerOpportuniteActive: {
      get() {
        return this.getIsComponentEnregistrerOpportuniteActive;
      },
      set(value) {
        this.setIsComponentEnregistrerOpportuniteActive(value);
      },
    },
  },
  methods: {
    ...Modal.mapMutations({
      setIsComponentEnregistrerOpportuniteActive:
      typesModal.SET_IS_COMPONENT_ENREGISTRER_OPPORTUNITE_ACTIVE,
      setIsComponentOuvrirMail: typesModal.SET_IS_COMPONENT_OUVRIR_MAIL,
    }),
    copyLink() {
      const domCreate = document.createElement('input');
      document.body.appendChild(domCreate);
      domCreate.setAttribute('value', this.opportunite.permalink);
      domCreate.select();
      try {
        const isCopied = document.execCommand('copy');
        if (isCopied) toastConfirmation('Lien copié');
        else gestionErreur('Problème lors de la copie du lien');
      } catch (e) {
        gestionErreur('Problème lors de la copie  du lien', e);
      }
    },
    ouvrirNouvelleFenetre() {
      window.open(this.opportunite.previewLink);
    },
    ouvrirModalEnvoiMail() {
      this.isComponentOuvrirEnvoiMail = true;
      this.isComponentEnregistrerOpportuniteActive = false;
    },
    // Solution https://stackoverflow.com/questions/43432892/force-download-get-request-using-axios/44021663?utm_medium=organic&utm_source=google_rich_qa&utm_campaign=google_rich_qa
    exporterPdf() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      HTTP.get(this.opportunite.url,
        { responseType: 'blob' },
      ).then((response) => {
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      }).catch((e) => {
        gestionErreur('Erreur lors de l\'export PDF de l\'opportunité', e);
        loadingComponent.close();
        throw e;
      });
    },
    recapitulatif(type) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      const url = type === 'PDF' ? this.opportunite.urlRecap : this.opportunite.urlRecap + '-excel';
      HTTP.get(url,
        { responseType: 'blob' },
      ).then((response) => {
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      }).catch((e) => {
        gestionErreur('Erreur lors de l\'export PDF - EXCEL du récapitulatif de l\'opportunité', e);
        loadingComponent.close();
        throw e;
      });
    },
  },
};
</script>

<style scoped>
  .cloud-check {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/envoyerOpportunite/enregistrerOpportunite.vue